var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 362.023 362.023"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 60.341h362.023v241.34H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M34.315 118.089l-23.579-10.406 23.579-10.405 10.403-23.577 10.405 23.577 23.578 10.405-23.578 10.406-10.405 23.575z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M44.718 86.696l6.426 14.561 14.562 6.426-14.562 6.426-6.426 14.561-6.424-14.561-14.562-6.426 14.562-6.426z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 212.496h362.023v15.743H0zm0 31.478h362.023v15.743H0z",
  fill: "#ffda44"
})));

export default SvgAw;